import * as React from "react";
import { AppBar, Box, Grid, Link, MenuItem, Modal, Toolbar, Typography } from "@mui/material";
import { Facebook, Instagram, LinkedIn, Twitter, Home, Group, MiscellaneousServices, Download, PrivacyTip, HelpOutline } from "@mui/icons-material";
import { SocialIcons } from "../StyledComponent";
import { useTranslation } from "react-i18next";

// Modal styles
const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#9bcde6",
  border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  borderRadius: "10px",
  width: "300px",
  textAlign: "center",
};

const policiesModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#9bcde6",
  border: "2px solid #000",
  boxShadow: 24,
  p: 3,
  borderRadius: "10px",
  width: "600px",
  maxHeight: "300px",
  overflowY: "auto",
  textAlign: "left",
};

const contactUsModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#9bcde6",
  border: "2px solid #000",
  boxShadow: 24,
  p: 3,
  borderRadius: "10px",
  width: "400px",
  textAlign: "left",
};

const menuStyle = {
  fontSize: "11px",
  color: "#fff",
  fontWeight: 400,
  paddingLeft: 0,
  paddingRight: "10px",
  zIndex: 100,
};

// Reusable Modal Component
const ModalComponent = ({ open, onClose, children, sx }) => (
  <Modal open={open} onClose={onClose}>
    <Box sx={sx || modalBoxStyle}>{children}</Box>
  </Modal>
);

function AboveFooterNew() {
  const [openModal, setOpenModal] = React.useState("");
  const [openAccessHelp, setOpenAccessHelp] = React.useState(false);
  const [openPolicies, setOpenPolicies] = React.useState(false);
  const [openConnect, setOpenConnect] = React.useState(false);
  const [openUsefulLinks, setOpenUsefulLinks] = React.useState(false);
  const [openContactUs, setOpenContactUs] = React.useState(false);
  const { t } = useTranslation();
  const handleOpen = (modalName) => {
    if (modalName === "accessHelp" || modalName === "rightInfo" || modalName === "termsUse" || modalName === "webInfoMan") {
      setOpenAccessHelp(true);
    } else if (modalName === "policies") {
      setOpenPolicies(true);
    } else if (modalName === "connect") {
      setOpenConnect(true);
    } else if (modalName === "usefulLinks") {
      setOpenUsefulLinks(true);
    } else if (modalName === "contactUs") {
      setOpenContactUs(true);
    }

    setOpenModal(modalName);
  };

  const handleClose = () => {
    setOpenModal("");
    setOpenAccessHelp(false);
    setOpenConnect(false);
    setOpenContactUs(false);
    setOpenUsefulLinks(false);
    setOpenPolicies(false);
  };
  const isOpen = (modalName) => openModal === modalName;

  return (
    <AppBar position="static" sx={{ backgroundColor: "#373737", zIndex: 10, overflowX: "auto" }} className="footer-menu bottom-appbar-footer">
      <Toolbar sx={{ color: "White", paddingLeft: "7px!important", minHeight: "35px" }} variant="dense">
        {[
          { label: "FASTPAS.HOME.FOOTER.ACCESSIBILITY_HELP", name: "accessHelp" },
          { label: "FASTPAS.HOME.FOOTER.RIGHT_TO_INFORMATION", name: "rightInfo" },
          { label: "FASTPAS.HOME.FOOTER.POLICIES", name: "policies" },
          { label: "FASTPAS.HOME.FOOTER.TERMS_OF_USE", name: "termsUse" },
          // { label: "Connect", name: "connect" },
          { label: "FASTPAS.HOME.FOOTER.USEFUL_LINKS", name: "usefulLinks" },
          { label: "FASTPAS.HOME.FOOTER.WEB_INFORMATION_MANAGER", name: "webInfoMan" },
          { label: "FASTPAS.HOME.FOOTER.CONTACT_US", name: "contactUs" },
          { label: "FASTPAS.HOME.FOOTER.HELPDESK", name: "helpdesk", link: "https://mainet.abmindia.com/training/" },
        ].map(({ label, name }) => (
          <MenuItem
            key={name}
            sx={menuStyle}
            onClick={() => (name === "helpdesk" ? window.open("https://mainet.abmindia.com/training/", "_blank") : handleOpen(name))}
            tabIndex={0}
          >
            {t(label)}
          </MenuItem>
        ))}

        <ModalComponent open={openPolicies} onClose={handleClose} sx={policiesModal}>
          <Typography variant="h6" gutterBottom>
            Refund Policy
          </Typography>
          <Typography variant="body2" gutterBottom>
            Refunds will be returned using the original method of payment – for example, if a donation has been made by credit card, the refund will
            be credited by the same mode of channel to the same credit card by the merchant. This applies to all payment modes used by the customer.
          </Typography>
          <Typography variant="body2" gutterBottom>
            If the received product is not as per the customer's selection, the customer can contact us within 10 working days. The refund will be
            processed as per the bank's TAT/norms.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ marginTop: 2 }}>
            Cancellation Policy
          </Typography>
          <Typography variant="body2" gutterBottom>
            Once the product is dispatched, cancellation will not be entertained. However, customers can cancel the product within 5 to 6 days before
            it gets delivered.
          </Typography>
          <Typography variant="body2" gutterBottom>
            Alternatively, merchants should update the disclaimer on the website.
          </Typography>
          <Typography variant="body2">Refunds/Cancellations will not be entertained once the customer has made the payment.</Typography>
        </ModalComponent>

        {/* Reusable modals */}
        <ModalComponent open={openAccessHelp} onClose={handleClose}>
          <Typography variant="h6">In Progress</Typography>
        </ModalComponent>

        <ModalComponent open={openConnect} onClose={handleClose}>
          <Grid container justifyContent="center">
            {[
              { icon: <Facebook sx={{ fontSize: 50, color: "blue" }} />, label: "Facebook" },
              { icon: <Instagram sx={{ fontSize: 50 }} />, label: "Instagram" },
              { icon: <LinkedIn sx={{ fontSize: 50 }} />, label: "LinkedIn" },
              { icon: <Twitter sx={{ fontSize: 50, color: "#1C9CEA" }} />, label: "Twitter" },
            ].map(({ icon, label }) => (
              <SocialIcons key={label} style={{ padding: "10px" }}>
                <Link href="#" target="_blank" rel="noopener">
                  {icon}
                  <Typography>{label}</Typography>
                </Link>
              </SocialIcons>
            ))}
          </Grid>
        </ModalComponent>

        <ModalComponent open={openUsefulLinks} onClose={handleClose}>
          {[
            { icon: <Home />, text: "Home" },
            { icon: <Group />, text: "About Us" },
            { icon: <MiscellaneousServices />, text: "Services" },
            { icon: <HelpOutline />, text: "Helpdesk" },
            { icon: <Download />, text: "Downloads" },
            { icon: <PrivacyTip />, text: "Privacy Policy" },
          ].map(({ icon, text }) => (
            <Typography gutterBottom key={text}>
              <Link
                href={text === "Helpdesk" ? "https://mainet.abmindia.com/training/" : "#"}
                target={text === "Helpdesk" ? "_blank" : "_self"}
                rel={text === "Helpdesk" ? "noopener noreferrer" : undefined}
                color="inherit"
                style={{ textDecoration: "none", fontSize: "17px" }}
              >
                <span style={{ paddingRight: "5px" }}>{icon}</span>
                {text}
              </Link>
            </Typography>
          ))}
        </ModalComponent>

        <ModalComponent open={openContactUs} onClose={handleClose} sx={contactUsModal}>
          <Typography variant="body1" gutterBottom sx={{ lineHeight: 1.6 }}>
            Our office operates on government working days, as per the following schedule:
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ lineHeight: 1.6, fontWeight: "medium" }}>
            Monday to Saturday: 9:30 AM to 6:30 PM
            <br />
            Sunday: Closed
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.6, marginTop: 2, marginBottom: 2 }}>
            For any assistance beyond working hours, kindly raise a Helpdesk Ticket. Our team will review and respond on the next working day.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ textAlign: "center", fontWeight: "bold" }}>
            U.P. Awas Bandhu
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ lineHeight: 1.6 }}>
            RWWV+J99, Trilokinath Marg Hajratganj Janpath Market,
            <br />
            Lalbagh, Lucknow, Uttar Pradesh, 226001
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ lineHeight: 1.6 }}>
            Phone: 08064522131 (Prefix with 0 when dialing)
          </Typography>
          <Typography variant="body1">
            Email: <Link href="mailto:awasbandhu@gmail.com">awasbandhu[at]gmail[dot]com</Link>
          </Typography>
        </ModalComponent>
      </Toolbar>
    </AppBar>
  );
}

export default AboveFooterNew;
